
import VueScrollTo from 'vue-scrollto'
import { productTableMixin } from '~/mixins'

export default {
  name: 'FeaturesOrderingInAccessory',
  mixins: [productTableMixin],
  props: {
    features: {
      type: Array,
      default: () => [],
    },
    downloads: {
      type: Object,
      default: () => ({}),
    },
    orderingAccessory: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeTab: this.$t('front.product.tabs.features'),
      expanded: false,
      animationInAction: false,
      firstTabHeight: 0,
    }
  },
  computed: {
    shouldExpand() {
      return this.firstTabHeight > 300
    },
    tabHeadings() {
      // used in product table mixin
      return ['features', 'downloads', 'ordering']
    },
  },
  watch: {
    expanded(newValue) {
      this.animationInAction = true
      setTimeout(
        () => {
          this.animationInAction = false
        },
        newValue ? 500 : 75,
      )
      if (newValue === false) {
        try {
          VueScrollTo.scrollTo(this.$refs.tab[0], 600, {
            offset: -(window?.innerHeight || 180) / 2,
          })
        } catch (ex) {
          this.$sentry.captureException(ex)
        }
      }
    },
  },
  updated() {
    this.setFirstTabHeight()
  },
  mounted() {
    this.setFirstTabHeight()
  },
  methods: {
    setFirstTabHeight() {
      const firstTabRefScrollHeight = this.$refs?.tab?.scrollHeight || 0
      if (
        this.firstTabHeight <= 300 &&
        firstTabRefScrollHeight > 300 &&
        this.firstTabHeight !== firstTabRefScrollHeight
      ) {
        this.firstTabHeight = firstTabRefScrollHeight
      }
    },
  },
}
